$(document).ready(function(){

  $('.pp_flavor_sel_card').click(function(evt){
    evt.preventDefault();
  });

  $('.pp_delivery_mode_sel').click(function(){
    $('.pp_delivery_mode_sel').removeClass('active');
    $(this).addClass('active');
    var mode = $(this).attr('data');

    if (mode == 'autodelivery'){
      var currentSellingPlan = $('.pp_form_sellingPlan_js').attr('data-selling-plan');
      $('.pp_form_sellingPlan_js').val(currentSellingPlan);
      $('.onlySubVisible').show();
      $('.pp_sub_content').show();
      $('.pp_onetime_content').hide();
      $('.pp_sub_box_select').trigger('change');
      $('.sub_price').show();
      $('.otp_price').hide();
      $('.cu_btn_atc.pdp_adding_to_cart_mn_btn').html('AUTOSHIP & SAVE');
      $('.pp_sub_content').find('.pdp_qty_outer_block[data="3"]').trigger('click');
      $('.pp_autoship_disclaimer').show();
    } else {
      $('.pp_form_sellingPlan_js').val('');
      $('.onlySubVisible').hide();
      $('.pp_sub_content').hide();
      $('.pp_onetime_content').show();
      $('.otp_price').show();
      $('.pp_autoship_disclaimer').hide();
      $('.sub_price').hide();
      $('.pp_uk_quantity__js').val('1');
      $('.cu_btn_atc.pdp_adding_to_cart_mn_btn').html('BUY');
      $('.pp_onetime_content').find('.pdp_qty_outer_block[data="1"]').trigger('click');
    }
  });

  $('.main-product__media').slick({
    slidesToShow: 1,
    infinite: true,
    slidesToScroll: 1,
    swipeToSlide: true,
    centerMode: true,
    arrows: true,
    fade: true,
    prevArrow: $(".main-product__left"),
    nextArrow: $(".main-product__right"),
    asNavFor: $('.main-product__media-thumbnails'),
  });

  $('.main-product__media-thumbnails').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    arrows: true,
    centerMode: true,
    asNavFor: $('.main-product__media'),
    variableWidth: true,
    focusOnSelect: true,
  });

  

  $('.pdp_kodel_verta_carousel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0573/6182/5865/files/SVG_1.png?v=1724591972'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0573/6182/5865/files/SVG.png?v=1724591971'/></button>",
  });

  $('.pdp_gift_variant_cel').click(function(){
    $('.pdp_gift_variant_cel').removeClass('active');
    $(this).addClass('active');
    var currentId = $(this).attr('data-id');
    $('.pdp_giftcard_id').attr('value', currentId);
    $('.pdp_As_price').hide();
    $('.pdp_As_price[data-id="'+currentId+'"]').show();
  });

  $('.pdp_as_sel').click(function(){
    $(this).closest('.pdp_as_selector').find('.pdp_as_sel').removeClass('active');
    $(this).addClass('active');
    var currentVal = $(this).attr('data');
    $('.pdp_as_whole_content').hide();
    $('.pdp_as_whole_content[data="'+currentVal+'"]').show();
    $('.pdp_As_content').hide();
    $('.pdp_As_content[data="'+currentVal+'"]').show();
    var videoDesk = $('.Desktop_only .pdp_As_content[data="'+currentVal+'"]').find('video')[0];
    if(videoDesk) videoDesk.play();
    var videoMob = $('.Mobile_only .pdp_As_content[data="'+currentVal+'"]').find('video')[0];
    if(videoMob) videoMob.play();
    var currentId = $(this).attr('data-id');
    $(this).closest('.pdp_meta_box').find('.ppIdInput_js').val(currentId);
    $('.pdp_qty_expanded_main_product .pdp_quantity_cell.pp_main_quantity_cell').hide();
    $('.pdp_qty_expanded_main_product .pdp_quantity_cell.pp_main_quantity_cell[data-id="'+currentId+'"]').css('display', 'flex');
    $('.pdp_qty_expanded_main_product').attr('data-id', currentId);
  });
  

$('.pp_flavor_sel .pdp_as_sel').click(function () {
  const selectedFlavor = $(this).attr('data');
  const currentId = $(this).attr('data-id');

  // Update product title on both desktop and mobile
  const titleText = $('#flavor-product-titles').find(`[data-flavor="${selectedFlavor}"]`).text().trim();
  document.querySelectorAll('.main_title_for_product__js, .Mobile_only.pp_meta_box_bot h1.pp_main_title').forEach(titleEl => {
    const strongText = titleEl.querySelector('strong')?.innerText || '';
    titleEl.innerHTML = `<strong>${strongText}</strong> ${titleText}`;
  });

  // Update hidden variant input
  $('.pp_uk_variant__js').val(currentId);

  // 🔁 Sync with other sections (like flavor discovery carousel)
  $('.pdp_as_sel').removeClass('active');
  $(`.pdp_as_sel[data="${selectedFlavor}"]`).addClass('active');
});

  // When a flavor is clicked in the discovery section, trigger PDP logic
$('.pdp_as_outer .pdp_as_sel').click(function () {
  const selectedFlavor = $(this).attr('data');

  // Trigger click on the matching PDP selector (first section)
  $(`.pp_flavor_sel .pdp_as_sel[data="${selectedFlavor}"]`).trigger('click');
});

  $('.pp_sub_box_select').change(function(){
    var currentVal = $(this).val();
    $('.pp_form_sellingPlan_js').val(currentVal);
    var currentOption = $(this).find('option:selected');
    var currentHTML = currentOption.html();
    var prices = currentHTML.match(/£(\d+\.\d+)/g);
    if (prices && prices.length >= 2) {
      $('.sub_price').find('.pfu_mn_price').html(prices[0]);
      $('.sub_price').find('.pfu_pc_price').html(prices[1]);
    }
    if (currentVal == '689890853197') {
      $('.pp_uk_quantity__js').val('3');
    } else if (currentVal == '689890885965') {
      $('.pp_uk_quantity__js').val('6');
    }
  });

  var iconsLoading = document.querySelector('.pdp_icons_line2_loading');
  var iconsContainer = document.querySelector('.pdp_icons_line2');
  if (iconsLoading && iconsContainer) {
    iconsContainer.style.display = 'none';
    iconsContainer.style.opacity = '0';
    iconsLoading.style.display = 'flex';

    $(iconsContainer).on('init', function () {
      iconsLoading.style.display = 'none';
      iconsContainer.style.display = 'block';
      iconsContainer.style.opacity = '1';
      iconsContainer.style.transition = 'opacity 0.2s ease-in';
    });

    $(iconsContainer).slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 1000,
      arrows: false,
      pauseOnHover: false,
      responsive: [{
        breakpoint: 320,
        settings: { slidesToShow: 3 }
      }]
    });
  }

  $('.pdp_gerio_kelione_carousel').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    centerMode: false,
    centerPadding: '100px',
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0573/6182/5865/files/SVG_1.png?v=1724591972'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0573/6182/5865/files/SVG.png?v=1724591971'/></button>",
    responsive: [
      { breakpoint: 1024, settings: { centerMode: false }},
      { breakpoint: 678, settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: false }}
    ]
  });

  $('.pdp_icons_line').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false,
    pauseOnHover: false
  });

  $('.pdp_accordion_line').click(function(){
    $(this).toggleClass('active');
    $(this).find('.pdp_accordion_info').slideToggle();
  });

  $('.pdp_qty_outer_block').click(function(){
    $('.pdp_qty_outer_block').removeClass('active');
    $(this).addClass('active');
    $('.pdp_qty_outer_block.active .pdp_select_qty_option__js').each(function(){
      if ($(this).val() == 'pasirink') {
        $(this).closest('.pdp_qty_expanded_main_product').addClass('needsAttention');
      }
    });
    var type = $(this).attr('data');
    $('.pdp_giftcard_type').val(type === 'fizinis' ? 'fizinis' : 'elektroninis');

    var currentMode = $('.pp_delivery_mode_sel.active').attr('data');
if (currentMode === 'autodelivery') {
  var selectedPlanId = $(this).attr('data');
  $('.pp_form_sellingPlan_js')
    .val(selectedPlanId)
    .attr('data-selling-plan', selectedPlanId);
}
  });

  $('.pdp_select_qty_option__js').change(function(){
    $('.pdp_qty_expanded_main_product').removeClass('needsAttention');
    $('.pdp_qty_outer_block.active .pdp_select_qty_option__js').each(function(){
      if ($(this).val() == 'pasirink') {
        $(this).closest('.pdp_qty_expanded_main_product').addClass('needsAttention');
      }
    });
  });

 $('.pdp_adding_to_cart_mn_btn').off('click').on('click', function () {
  const mode = $('.pp_delivery_mode_sel.active').attr('data');
  const $qtyInput = $('.pp_uk_quantity__js');

  if (mode === 'onetime') {
  const activeBlock = $('.pp_onetime_content .pdp_qty_outer_block.active');
  const blockData = activeBlock.attr('data');
  const items = [];

  // Always add the "main" selected flavor
  const mainVariantId = $('.pp_uk_variant__js').val();
  if (mainVariantId) {
    items.push({ id: mainVariantId, quantity: 1 });
  }

  // Collect all expanded product dropdowns
  const expandedProducts = activeBlock.find('.pdp_qty_expanded_main_product');

  expandedProducts.each(function (index) {
    const variantId = $(this).find('.pdp_select_qty_option__js').val();
    if (variantId && variantId !== 'pasirink') {
      let qty = 1;

      // 🔥 If block is "6" → the LAST 2 expanded products get 2x
      if (blockData === '6' && index >= expandedProducts.length - 2) {
        qty = 2;
      }

      items.push({ id: variantId, quantity: qty });
    }
  });

  if (items.length) {
    $qtyInput.val('0');
    $.post({
      url: '/cart/add.js',
      data: JSON.stringify({ items }),
      contentType: 'application/json',
      dataType: 'json',
      success: function () {
        $('.main_trigger_to_atc').trigger('click');
      }
    });
  }
}

 else if (mode === 'autodelivery') {
    const selectedPlanId = $('.pp_sub_content .pdp_qty_outer_block.active').attr('data');
    const items = [];

    $('.pp_sub_content .pdp_qty_outer_block.active .pdp_qty_expanded_main_product').each(function (index) {
      const variantId = $(this).find('.pdp_select_qty_option__js').val();
      if (variantId && variantId !== 'pasirink') {
        const qty = (
          (selectedPlanId === '691762594125' || selectedPlanId === '691554943309') &&
          index <= 1
        ) ? 2 : 1;
        items.push({ id: variantId, quantity: qty, selling_plan: selectedPlanId });
      }
    });

    if (items.length) {
      $qtyInput.val('0');
      $.post({
        url: '/cart/add.js',
        data: JSON.stringify({ items }),
        contentType: 'application/json',
        dataType: 'json',
        success: function () {
          $('.main_trigger_to_atc').trigger('click');
        }
      });
    }
  }
});



  // --- ✅ MEDIA IMAGE UPDATE ON FLAVOR SELECT ---
  const productHandles = {
    "saltalankiai": "goodie-fermented-sea-buckthorn-drink",
    "salyklas": "goodie-fermented-rye-malt-drink",
    "aronijos": "new-goodie-fermented-aronia-drink",
    "serbentai": "goodie-fermented-black-currant-drink"
  };

  

  function updateQuantitySelector(selectedFlavor) {
    const product = products[selectedFlavor];
    if (!product) return;

    // Update all .pdp_qty_expanded_main_product blocks with ID #quantity-selector
    document.querySelectorAll('#quantity-selector').forEach(container => {
      const imageEl = container.querySelector('.pdp_qty_main_image img');
      const titleEl = container.querySelector('.pdp_qty-title .head');
      if (imageEl) imageEl.setAttribute('src', product.image);
      if (titleEl) titleEl.textContent = product.title;
    });

    const select = document.querySelector('.pdp_qty_outer_block[data="1"] .pdp_select_qty_option__js');
    if (select) select.value = product.id;

    document.querySelectorAll('.pdp_qty_outer_block[data="2"] .pdp_select_qty_option__js, .pdp_qty_outer_block[data="3"] .pdp_select_qty_option__js').forEach(sel => sel.value = 'pasirink');
  }

  const productMediaWrapper = document.querySelector("#product-media-wrapper");

  function updateProductMediaFromImages(images) {
  const productMediaWrapper = document.querySelector("#product-media-wrapper");
  if (!images || !productMediaWrapper) return;

  productMediaWrapper.style.opacity = "0.2";

  const imageHtml = images.map(img => `<div class="product-image"><img src="${img.src}" alt=""></div>`).join('');
  const thumbHtml = images.map(img => `<div class="product-thumbnail"><img src="${img.src}" alt="" width="100"></div>`).join('');

  productMediaWrapper.innerHTML = `
    <div class="main-product__media2">${imageHtml}</div>
    <div class="main-product__media-thumbnails2">${thumbHtml}</div>
    <div class="main-product__swipe">
      <div class="main-product__arrow main-product__left">${$('.main-product__left').html() || ''}</div>
      <span class="body-text body-text--sm main-product__swipe-text">${$('.main-product__swipe-text').html() || ''}</span>
      <div class="main-product__arrow main-product__right">${$('.main-product__right').html() || ''}</div>
    </div>`;

  reinitializeSlick(() => {
    setTimeout(() => productMediaWrapper.style.opacity = "1", 200);
  });
}

  function reinitializeSlick(callback) {
    $(".main-product__media2, .main-product__media-thumbnails2").each(function () {
      if ($(this).hasClass("slick-initialized")) $(this).slick("unslick");
    });

    $(".main-product__media2").slick({
      slidesToShow: 1,
      infinite: true,
      slidesToScroll: 1,
      swipeToSlide: true,
      centerMode: true,
      arrows: true,
      fade: true,
      prevArrow: $(".main-product__left"),
      nextArrow: $(".main-product__right"),
      asNavFor: ".main-product__media-thumbnails2"
    });

    $('.main-product__media-thumbnails2')
  .on('init', function () {
    $(this).removeClass('hidden-before-init').css({ display: 'block' }).animate({ opacity: 1 }, 100);
  })
  .slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    centerMode: false,
    swipeToSlide: true,
    variableWidth: false,
    focusOnSelect: true,
    touchMove: true,
    draggable: true,
    asNavFor: '.main-product__media2',
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: false
        }
      }
    ]
  });

    if (callback) callback();
  }


const products = {}; // product cache

function getProductData(flavor) {
  return new Promise((resolve, reject) => {
    if (products[flavor]) return resolve(products[flavor]);

    const handle = productHandles[flavor];
    if (!handle) return reject("No handle found");

    fetch(`/products/${handle}.json`)
      .then(r => r.ok ? r.json() : Promise.reject("Fetch failed"))
      .then(data => {
        if (!data?.product?.variants?.length) return reject("No variants");

        products[flavor] = {
          id: data.product.variants[0].id,
          title: data.product.title,
          image: data.product.images[0]?.src || '',
          images: data.product.images
        };
        resolve(products[flavor]);
      });
  });
}
 function applyFlavorSelection(flavor) {
  getProductData(flavor).then(product => {
    updateQuantitySelector(flavor);

    const titleText = $('#flavor-product-titles').find(`[data-flavor="${flavor}"]`).text().trim();
    document.querySelectorAll('.main_title_for_product__js, .Mobile_only.pp_meta_box_bot h1.pp_main_title').forEach(titleEl => {
      const strongText = titleEl.querySelector('strong')?.innerText || '';
      titleEl.innerHTML = `<strong>${strongText}</strong> ${titleText}`;
    });

    updateProductMediaFromImages(product.images);
  });
}

$('.pdp_as_sel').on('click', function () {
  const selectedFlavor = $(this).attr('data');
  applyFlavorSelection(selectedFlavor);
});

const defaultFlavor = $('.pdp_as_sel.active').attr('data');
if (defaultFlavor) {
  applyFlavorSelection(defaultFlavor);
}
  });

